define('views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-set',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/exercise/weight/weight-set',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-set.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VWeightExerciseSet,
    // templates
    TWeightEditSet
) {

    var VWeightEditSet = VWeightExerciseSet.extend({
        template: TWeightEditSet,

    });

    return VWeightEditSet;

});

